<template>
    <div id="loginDesktop">
        <svgicon class="logo" v-if="!$store.state.cogir" src="svg/logo.svg" :width=240 :height=248></svgicon>
        <div class="logo-container" v-if="$store.state.cogir">
            <img class="logo" src="@/assets/img/logo-cogir.png">
        </div>
        <div class="page">
            <div class="card">

                <template v-if="show == 'intro'">
                    <div class="title">{{ $t("login.welcome").replace('%replace%',$store.state.cogir ? 'Octopus' : 'Humaniti') }}</div>
                    <div class="content">
                        <div class="btn btn-primary mb20" @click="setCurrentPage('login')">{{ $t("login.open_session") }}</div>
                        <div class="btn btn-secondary mb20" @click="toNoAccount">{{ $t("login.no_account") }}</div>
                        <a @click="setCurrentPage('forgot')">{{ $t("login.forgot") }}</a>
                    </div>
                </template>

                <template v-if="show == 'login'">
                    <div class="title">
                        {{ $t("login.connection") }}
                    </div>
                    <div class="content-login">
                        <label class="input-label">{{ $t("user.username") }}</label>
                        <input type="text" class="mb20" v-model="user.username" autocomplete="off">
                        <label class="input-label">{{ $t("user.password") }}</label>
                        <input type="password" class="mb20" v-model="user.password" autocomplete="off">
                        <div class="bottom">
                            <div class="remember">
                                <input id="remember-me" type="checkbox" v-model="user.rememberMe">
                                <label for="remember-me">{{ $t("login.remember_me") }}</label>
                            </div>
                            <div class="forgot-pw" @click="setCurrentPage('forgot')" >{{ $t("login.forgot_password") }}</div>
                        </div>
                        <div class="actions">
<!--                            <div class="btn btn-secondary" @click="show = 'intro'">{{ $t("navigation.back") }}</div>-->
                            <button @click="login" class="btn btn-primary">{{ $t("login.connection") }}</button>
                        </div>
                    </div>
                </template>

                <template v-if="show == 'forgot'">
                    <div class="title">{{ $t("login.reset_password") }}</div>
                    <div class="content-forgot">
                        <div class="description">
                            {{ $t("login.reset_password_text") }}
                        </div>
                        <label for="">{{ $t("user.email") }}</label>
                        <input type="text" class="mb20" v-model="user.emailForgot">
                        <div class="actions">
                            <div class="btn btn-secondary" @click="setCurrentPage('intro')">{{ $t("navigation.back") }}</div>
                            <div class="btn btn-primary" @click="resetPassword">{{ $t("login.reset") }}</div>
                        </div>
                    </div>
                </template>

            </div>
        </div>

        <div class="info-footer">
            <div class="copyright" >© {{ (new Date()).getFullYear() }} {{$store.state.cogir ? 'Octopus' : 'Humaniti'}}. All Rights Reserved.</div>
        </div>

    </div>
</template>

<script>
    export default {

        name: "LoginDesktop",

        props: {

            login: Function,
            toNoAccount: Function,
            resetPassword: Function,
            setLocale: Function,
            setCurrentPage: Function,

            user: Object,
            show: String

        }

    }
</script>

<style lang="scss" scoped>
    #loginDesktop {
        padding: 0 50px 50px;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
        align-items: center;
        overflow-y: auto;
    }
    
    .page {
        flex-grow: 1;
        flex-shrink: 3;
        flex-basis: 390px;
    }

    .logo , .logo-container{
        margin: 15px auto;
        flex-grow: 1;
        flex-shrink: 1;
    }
    
    .logo-container {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .card {
        width: 480px;
        border-radius: 5px;
        .content {
            text-align: center;
        }

        .content-login {
            display: flex;
            flex-direction: column;

            .btn {
                width: 100%;
            }
        }

        .content-forgot {
            display: flex;
            flex-direction: column;

            .description {
                text-align: center;
                padding: 0 10px 20px;
                font-size: 18px;
            }

            .actions{
                display: flex;
                justify-content: space-Between;
                margin-top: 10px;

                .btn{
                    flex-grow: 1;
                    flex-basis: 0;
                    &:not(:last-child) {
                        margin-right: 20px;
                    }
                }
            }
        }

    }

    .input-label {
        font-size: 14px;
        padding-bottom: 8px;
    }

    .bottom {
        color: #405159;
        font-size: 16px;
        display: flex;
        font-weight: normal;
        margin-bottom: 22px;

        .remember {
            flex-grow: 1;
        }

        .forgot-pw {
            cursor: pointer;
        }
    }

    .info-footer {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        color: #808b91;
        font-size: 14px;
        text-align: center;
        
        .copyright {
            padding-top: 60px;
        }
    }

    .links {
        display: flex;

        a {
            color: #808b91;
        }

        a:not(:last-child):after {
            content: "";
            display: inline-block;
            height: 10px;
            width: 2px;
            background-color: #808b91;
            margin: 0 15px;
        }

    }

</style>